// Framer Motion Animation Variants

// Fade In Animation
export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};

// Fade In Up Animation
export const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.8, ease: 'easeOut' }
  }
};

// Fade In Down Animation
export const fadeInDown = {
  hidden: { opacity: 0, y: -30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};

// Slide In From Left
export const slideInLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.5, ease: 'easeOut' }
  }
};

// Slide In From Right
export const slideInRight = {
  hidden: { opacity: 0, x: 100 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.5, ease: 'easeOut' }
  }
};

// Scale Up Animation
export const scaleUp = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { 
    opacity: 1, 
    scale: 1,
    transition: { duration: 0.5, ease: 'easeOut' }
  }
};

// Stagger Container (for lists/grids)
export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

// Stagger Item
export const staggerItem = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.5 }
  }
};

// Menu Sidebar Animation
export const menuSidebar = {
  hidden: { x: '-100%' },
  visible: { 
    x: 0,
    transition: { duration: 0.4, ease: 'easeInOut' }
  },
  exit: { 
    x: '-100%',
    transition: { duration: 0.3, ease: 'easeInOut' }
  }
};

// Submenu Animation
export const submenu = {
  hidden: { x: -100, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.3, ease: 'easeOut' }
  },
  exit: {
    x: -100,
    opacity: 0,
    transition: { duration: 0.2, ease: 'easeIn' }
  }
};

// Hover Scale Effect
export const hoverScale = {
  rest: { scale: 1 },
  hover: { 
    scale: 1.05,
    transition: { duration: 0.3, ease: 'easeInOut' }
  }
};

// Card Hover Effect
export const cardHover = {
  rest: { y: 0, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' },
  hover: { 
    y: -10,
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
    transition: { duration: 0.3, ease: 'easeOut' }
  }
};

// Page Transition
export const pageTransition = {
  initial: { opacity: 0, y: 20 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' }
  },
  exit: { 
    opacity: 0,
    transition: { duration: 0.3 }
  }
};

// Hero Text Animation
export const heroText = {
  hidden: { opacity: 0, y: 50 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.8, 
      ease: 'easeOut',
      delay: 0.2 
    }
  }
};

// Image Reveal Animation
export const imageReveal = {
  hidden: { scale: 1.2, opacity: 0 },
  visible: { 
    scale: 1, 
    opacity: 1,
    transition: { duration: 1, ease: 'easeOut' }
  }
};

// Navbar Animation
export const navbar = {
  hidden: { y: -100, opacity: 0 },
  visible: { 
    y: 0, 
    opacity: 1,
    transition: { duration: 0.5, ease: 'easeOut' }
  }
};

// Button Tap Animation
export const buttonTap = {
  tap: { scale: 0.95 }
};

// Premium Parallax Effect
export const parallaxUp = {
  hidden: { y: 100, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.2, ease: [0.6, 0.05, 0.01, 0.9] }
  }
};

// Smooth Text Reveal with Blur
export const textReveal = {
  hidden: { opacity: 0, y: 30, filter: 'blur(10px)' },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: 0.8, ease: 'easeOut' }
  }
};

// Premium Image Hover with Scale & Blur
export const premiumImageHover = {
  rest: { scale: 1, filter: 'brightness(1)' },
  hover: {
    scale: 1.05,
    filter: 'brightness(1.1)',
    transition: { duration: 0.6, ease: 'easeInOut' }
  }
};

// Luxury Card with Shadow & Lift
export const luxuryCard = {
  rest: {
    y: 0,
    scale: 1,
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
    transition: { duration: 0.4, ease: 'easeOut' }
  },
  hover: {
    y: -15,
    scale: 1.02,
    boxShadow: '0 30px 60px rgba(0, 0, 0, 0.15)',
    transition: { duration: 0.4, ease: 'easeOut' }
  }
};

// Smooth Slide with Elastic Bounce
export const elasticSlide = {
  hidden: { x: -100, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: [0.34, 1.56, 0.64, 1],
      delay: 0.2
    }
  }
};

// Advanced Stagger with Different Delays
export const premiumStagger = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3,
      ease: 'easeOut'
    }
  }
};

// Premium Stagger Item with Scale
export const premiumStaggerItem = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: [0.6, 0.05, 0.01, 0.9] }
  }
};

// Floating Animation (continuous)
export const floating = {
  animate: {
    y: [0, -20, 0],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }
};

// Smooth Fade with Scale
export const fadeScale = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.7, ease: [0.6, 0.05, 0.01, 0.9] }
  }
};

// Premium Button Hover
export const premiumButton = {
  rest: {
    scale: 1,
    backgroundColor: '#8B7355',
    transition: { duration: 0.3 }
  },
  hover: {
    scale: 1.05,
    backgroundColor: '#6F5B44',
    boxShadow: '0 10px 25px rgba(139, 115, 85, 0.3)',
    transition: { duration: 0.3, ease: 'easeOut' }
  },
  tap: { scale: 0.98 }
};

// Reveal from Bottom with Clip Path
export const revealFromBottom = {
  hidden: {
    clipPath: 'inset(100% 0 0 0)',
    opacity: 0
  },
  visible: {
    clipPath: 'inset(0% 0 0 0)',
    opacity: 1,
    transition: { duration: 1, ease: [0.6, 0.05, 0.01, 0.9] }
  }
};

// Smooth Number Counter Effect
export const counterAnimation = {
  hidden: { opacity: 0, scale: 0.5 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: 'easeOut' }
  }
};